var bittoelatings_b = [{
        rule: "voertuie:create",
        bitmask: "1",
        blok: 1,
        beskrywing: "Skep van voertuie",
        groepe: ["voertuie", "setup"]
    },
    {
        rule: "voertuie:read",
        bitmask: "2",
        blok: 1,
        beskrywing: "Lees van voertuie",
        groepe: ["voertuie", "basis"]
    },
    {
        rule: "voertuie:update",
        bitmask: "4",
        blok: 1,
        beskrywing: "Veranderinge aan voertuie",
        groepe: ["voertuie", "setup"]
    },
    {
        rule: "voertuie:delete",
        bitmask: "8",
        blok: 1,
        beskrywing: "Verwydering van voertuie",
        groepe: ["voertuie", "setup"]
    },
    {
        rule: "voertuiekaart:update",
        bitmask: "16",
        blok: 1,
        beskrywing: "Uitreik van 'n kaart aan 'n voertuig",
        groepe: ["voertuie", "setup"]
    },
    {
        rule: "werknemers:create",
        bitmask: "32",
        blok: 1,
        beskrywing: "Skep van werknemers",
        groepe: ["werknemers", "setup"]
    },
    {
        rule: "werknemers:read",
        bitmask: "64",
        blok: 1,
        beskrywing: "Lees van werknemers",
        groepe: ["werknemers", "basis"]
    },
    {
        rule: "werknemers:update",
        bitmask: "128",
        blok: 1,
        beskrywing: "Veranderinge aan werknemers",
        groepe: ["werknemers", "setup"]
    },
    {
        rule: "werknemers:delete",
        bitmask: "256",
        blok: 1,
        beskrywing: "Verwydering van werknemers",
        groepe: ["werknemers", "setup"]
    },
    {
        rule: "werknemerskaart:update",
        bitmask: "512",
        blok: 1,
        beskrywing: "Uitreik van 'n kaart aan 'n werknemer",
        groepe: ["werknemers", "setup"]
    },
    {
        rule: "werknemerskoppel:update",
        bitmask: "1024",
        blok: 1,
        beskrywing: "Nooi 'n werknemer uit / koppel aan 'n boerdery",
        groepe: ["werknemers", "setup"]
    },
    {
        rule: "spanne:create",
        bitmask: "2048",
        blok: 1,
        beskrywing: "Skep van spanne",
        groepe: ["spanne", "setup"]
    },
    {
        rule: "spanne:read",
        bitmask: "4096",
        blok: 1,
        beskrywing: "Lees van spanne",
        groepe: ["spanne", "basis"]
    },
    {
        rule: "spanne:update",
        bitmask: "8192",
        blok: 1,
        beskrywing: "Veranderinge aan spanne",
        groepe: ["spanne", "setup"]
    },
    {
        rule: "spanne:delete",
        bitmask: "16384",
        blok: 1,
        beskrywing: "Verwydering van spanne",
        groepe: ["spanne", "setup"]
    },
    {
        rule: "lone:create",
        bitmask: "32768",
        blok: 1,
        beskrywing: "Maak betalings aan werknemers",
        groepe: ["lone", "finansieel"]
    },
    {
        rule: "lone:read",
        bitmask: "65536",
        blok: 1,
        beskrywing: "Sien lone en bonusse",
        groepe: ["lone", "finansieel"]
    },
    {
        rule: "lone:update",
        bitmask: "131072",
        blok: 1,
        beskrywing: "Verander aan betaalrekords",
        groepe: ["lone", "finansieel"]
    },
    {
        rule: "lone:delete",
        bitmask: "262144",
        blok: 1,
        beskrywing: "Revert betalings gemaak",
        groepe: ["lone", "finansieel"]
    },
    {
        rule: "ivj:read",
        bitmask: "524288",
        blok: 1,
        beskrywing: "Sien van intervertakking joernale",
        groepe: ["ivj", "finansieel"]
    },
    {
        rule: "oesskatting:create",
        bitmask: "1048576",
        blok: 1,
        beskrywing: "Doen 'n oesskatting",
        groepe: ["oesskatting", "aktiwiteite"]
    },
    {
        rule: "oesskatting:read",
        bitmask: "2097152‬",
        blok: 1,
        beskrywing: "Lees van oesskattings",
        groepe: ["oesskatting", "aktiwiteite"]
    },
    {
        rule: "oesskatting:update",
        bitmask: "4194304‬",
        blok: 1,
        beskrywing: "Veranderinge aan oesskatting",
        groepe: ["oesskatting", "aktiwiteite"]
    },
    {
        rule: "oesskatting:delete",
        bitmask: "8388608‬",
        blok: 1,
        beskrywing: "Verwydering van oesskattings",
        groepe: ["oesskatting", "aktiwiteite"]
    },
    {
        rule: "grondvog:create",
        bitmask: "16777216‬",
        blok: 1,
        beskrywing: "Neem 'n grondvog lesing",
        groepe: ["grondvog", "aktiwiteite", "verkenning"]
    },
    {
        rule: "grondvog:read",
        bitmask: "33554432‬",
        blok: 1,
        beskrywing: "Lees van grondvog lesings",
        groepe: ["grondvog", "aktiwiteite", "verkenning"]
    },
    {
        rule: "grondvog:update",
        bitmask: "67108864‬",
        blok: 1,
        beskrywing: "Veranderinge aan grondvog lesings",
        groepe: ["grondvog", "aktiwiteite", "verkenning"]
    },
    {
        rule: "grondvog:delete",
        bitmask: "134217728‬",
        blok: 1,
        beskrywing: "Verwydering van grondvog lesings",
        groepe: ["grondvog", "aktiwiteite", "verkenning"]
    },
    {
        rule: "onkruid:create",
        bitmask: "268435456‬",
        blok: 1,
        beskrywing: "Neem 'n onkruid lesing",
        groepe: ["onkruid", "aktiwiteite", "verkenning"]
    },
    {
        rule: "onkruid:read",
        bitmask: "536870912‬",
        blok: 1,
        beskrywing: "Lees van onkruid lesings",
        groepe: ["onkruid", "aktiwiteite", "verkenning"]
    },
    {
        rule: "onkruid:update",
        bitmask: "1073741824‬",
        blok: 1,
        beskrywing: "Veranderinge aan onkruid lesings",
        groepe: ["onkruid", "aktiwiteite", "verkenning"]
    },
    {
        rule: "onkruid:delete",
        bitmask: "2147483648‬",
        blok: 1,
        beskrywing: "Verwydering van onkruid lesings",
        groepe: ["onkruid", "aktiwiteite", "verkenning"]
    },
];

export default bittoelatings_b;